import { getRequest, postRequest } from "./RequestConfig";

export const handleFetchAllSurveys = async () => {
  try {
    const response = await getRequest("survey/all");
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const handleFetchVehicleType = async () => {
  try {
    const response = await getRequest("fleet/vehicle-types");
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const fetchSurveyWithFilter = async (name, createdDate, revisedDate) => {
  try {
    const response = await getRequest(
      `survey/all?${
        name === "created"
          ? "createdTs=" + createdDate
          : "lastUpdatedTs=" + revisedDate
      }`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submitImport = async (payload) => {
  try {
    const response = await postRequest("vehicle/bulk", payload);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const defaultExports = {
  handleFetchAllSurveys,
  fetchSurveyWithFilter,
  submitImport,
};
export default defaultExports;
